import _ from 'lodash';
import React from 'react';

import Icon from 'components/Icon';
import { ControlMap } from 'components/Toolbar/Controls/TextHorizontalAlignment/constants';
import { ControlOptions } from 'components/Toolbar/models';
import Dropdown from 'components/Toolbar/Shared/Dropdown';
import { AssetAlignmentType } from 'const';
import { intlGet } from 'utils/intlGet';
import { TextHorizontalAlignmentProps } from './models';
import styles from './styles.module.scss';

const TextHorizontalAlignment: React.FunctionComponent<TextHorizontalAlignmentProps> = (props) => {
  const { alignment, toggleAlignment, dataTestId = 'textHorizontalAlignment' } = props;

  return (
    <Dropdown className={styles.TextHorizontalAlignment} dataTestId={`${dataTestId}-dropdown`}>
      {_.map(ControlMap, ((options: ControlOptions & { name: string }, type: AssetAlignmentType) => {
        const { icon, name, title } = options;

        return (
          <div className={styles.item} key={title} onClick={toggleAlignment.bind(null, type)} data-testid={`${dataTestId}-item${type}`}>
            <Icon type={icon} size="badge" color={type === alignment ? 'primary' : 'secondary'} />
            <span className={styles.hint} data-testid={`${dataTestId}-type${type}`}>{intlGet('EditorToolbar.TextAlignment.Horizontal', name)}</span>
          </div>
        );
      }))}
    </Dropdown>
  );
};

export default TextHorizontalAlignment;
